var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g({attrs:{"width":_vm.width,"min-height":_vm.minHeight,"color":_vm.color}},_vm.eventHandlers),[_c('v-card-title',{staticClass:"black--text"},[_vm._v(" "+_vm._s(_vm.cardTitle)+" ")]),_c('v-card-text',{staticClass:"black--text"},[_vm._v(" "+_vm._s(_vm.cardText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }